import React from 'react';
import './../../style/css/navigation.css';
import { NavLink } from 'react-router-dom';
import { NavigationEntry as RouteEntry } from '../../models/navigation-entry';

interface Props {
    routeEntry: RouteEntry
    changeNavigationState?: (isOpen: boolean) => void;
}

export const NavigationEntry = (props: Props) => {
    return (
        <NavLink to={props.routeEntry.route} 
                     strict={true}
                     exact={true}
                     onClick={props.changeNavigationState ? () => props.changeNavigationState!(false) : undefined}
                     className="navigation-entry"
                     activeClassName="navigation-entry-active"
                     key={props.routeEntry.id}>
                { props.routeEntry.title }
        </NavLink>
    )
};